import React from "react";
import Lottie from "react-lottie";
import * as image from "../../lottie/loading.json";

// firebase import sections
import Banner from "./Banner";
import Social from "./Social";
import JustisNews from "./JustisNews";

export default function Loading() {
    return (
      <main className="gradient">
        <Banner />
        <Social />
        <JustisNews />
        <div className="flex justify-content-between align-items-center w-full px-5 lg:px-8  my-3">
          <div className="text-lg md:text-2xl">Featured News</div>
        </div>
        <div className=" flex h-20rem justify-content-center align-items-center">
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: image,
            }}
            height={100}
            width={100}
          />
        </div>
      </main>
    );
}
